(function ($) {
  function setupTemplateSelectors () {
    $('#position_onboarding_template_id, #position_offboarding_template_id').on('change', (event) => {
      const previewUrl = $(event.target).parents('form').data('preview-url')
      const templateId = parseInt(event.target.value)

      if (isNaN(templateId)) {
        $(event.target)
          .parents('.block')
          .children('.template-preview')
          .html('')
      } else {
        $.ajax({
          type: 'GET',
          dataType: 'script',
          url: previewUrl,
          data: { template_id: templateId }
        })
      }
    })
  }

  window['positions/boarding/template_assignments#edit'] = setupTemplateSelectors
})(window.$)
